import React from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { FormSelectRow } from "./form-select-row";
import FormModalShell from "../ui/form-modal-shell";
import { CourierActions, CourierText } from "../ui/courier-fields";

const CreateZoneForm = ({
  closeModal,
  loading,
  apiError,
  cities = [],
  createCourierZone
}) => (
  <FormModalShell title="Add Zone" apiError={apiError} onClose={closeModal}>
    <Formik
      initialValues={{ name: "", city: "" }}
      validationSchema={Yup.object().shape({
        name: Yup.string().required("Required field"),
        city: Yup.string().required("Required field")
      })}
      onSubmit={values => {
        createCourierZone({
          name: values.name,
          city: Number(values.city)
        });
      }}
    >
      {formik => (
        <Form>
          <CourierText label="Zone Name" name="name" />
          <FormSelectRow
            label="City"
            name="city"
            value={formik.values.city}
            onChange={e => formik.setFieldValue("city", e.target.value)}
            error={formik.touched.city && formik.errors.city}
            required
            placeholder="Select city"
            options={(Array.isArray(cities) ? cities : []).map(c => ({
              value: c.id,
              label: c.name
            }))}
          />
          <CourierActions
            loading={loading}
            submitLabel="Add Zone"
            onCancel={closeModal}
          />
        </Form>
      )}
    </Formik>
  </FormModalShell>
);

export default CreateZoneForm;
